import PropTypes from 'prop-types';
import { useMutation } from '@apollo/client';
import AddLipidProfileMeasurementMutation from './AddLipidProfileMeasurementMutation';
import LaboratoryTestsQuery from '../Fetch/LaboratoryTestsQuery';

const AddLipidProfileMeasurementConnectorApollo = ({ children }) => {
  const [addBloodSugar, { data, loading, error }] = useMutation(AddLipidProfileMeasurementMutation);

  const createAddLipidProfileMeasurement = async (request) => {
    const response = await addBloodSugar({
      variables: { request },
      awaitRefetchQueries: true,
      refetchQueries: [
        {
          query: LaboratoryTestsQuery,
        },
      ],
    });

    return response;
  };

  return children({
    addLipidProfileMeasurement: {
      addMeasurement: createAddLipidProfileMeasurement,
      response: data,
      loading,
      error,
    },
  });
};

AddLipidProfileMeasurementConnectorApollo.propTypes = {
  children: PropTypes.func.isRequired,
};

export default AddLipidProfileMeasurementConnectorApollo;
